import { CSSProperties } from 'react'
import styled from 'styled-components'

export const AlignWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: #f0f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
`
